import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4045a657"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "meeting-affairs-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "meeting-affairs-img",
  src: "https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/20230612144221.png",
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "meeting-affairs-title" }, "会务中心", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "meeting-affairs-subtitle" }, "一站式会务管理，两分钟完成场地租赁到活动发布流程", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "meeting-affairs-details" }, "快速高效的会务管理流程，让您轻松完成活动策划和发布，从场地租赁到活动发布，活动举办提供全流程服务", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/20230612105940.png",
    alt: ""
  })
], -1))

import { ElMessage } from "element-plus";

import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "meetingAffairsView",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const linkEvent = () => {
  ElMessage({
    message: "暂未开放",
    type: "warning",
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "meeting-affairs-body" }, [
      _hoisted_2,
      _createElementVNode("div", { class: "meeting-affairs-content" }, [
        _createElementVNode("div", { class: "content-left" }, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", {
            onClick: linkEvent,
            class: "meeting-affairs-btn"
          }, "立即体验")
        ]),
        _hoisted_6
      ])
    ])
  ]))
}
}

})